import { useLocalSearchParams } from 'expo-router';

import RoutingConfirmation from '../../../../banking/components/paycheck-routing/RoutingConfirmation';

export default function PaycheckRoutingConfirmation() {
    const { isEdit } = useLocalSearchParams();
    const paycheckSplitExists = isEdit === 'true';

    return <RoutingConfirmation isEdit={paycheckSplitExists} />;
}
